module.exports = __webpack_public_path__ + "media/images/svg/logo_full-576c1d71f19f0c3c7438221267ba6ac8.svg";